/**
 * Address Constants
 * Shared constants for address validation and forms
 */

export const SOUTH_AFRICAN_PROVINCES = [
  'Gauteng',
  'Western Cape',
  'KwaZulu-Natal',
  'Eastern Cape',
  'Limpopo',
  'Mpumalanga',
  'North West',
  'Free State',
  'Northern Cape'
];

export const POSTAL_CODE_REGEX = /^\d{4}$/;

export const ADDRESS_VALIDATION_RULES = {
  streetAddress: {
    required: true,
    minLength: 5,
    maxLength: 200
  },
  city: {
    required: true,
    minLength: 2,
    maxLength: 100
  },
  province: {
    required: true
  },
  postalCode: {
    required: true,
    pattern: POSTAL_CODE_REGEX
  }
};
